
const extractPositionFromName = (question) => {
  const match = question.name.match(/\d+/);
  // nao precisa do check match.length mas queremos ser seguros
  if (match && match.length > 0) {
    question.position = +match[0]
    return +match[0];
  }
}

export default extractPositionFromName
